import { displayToast } from '../../../../helpers/notification';
import { MenuTypes as Type } from '../../../types/menu';

export function updateMenuItemRequest(id: any, body: any) {
  return {
    type: Type.EDIT_MENU_ITEM_REQUEST,
    body: body,
    id: id,
  };
}

export function updateMenuItemRequestSuccess(data: any) {
  return {
    type: Type.EDIT_MENU_ITEM_REQUEST_SUCCESS,
    payload: data,
  };
}

export function updateMenuItemRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.EDIT_MENU_ITEM_REQUEST_FAILURE,
    error: error,
  };
}

export function resetStateEditMenuItem() {
  return {
    type: Type.RESET_EDIT_MENU_ITEM_STATE,
  };
}
